module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_E.6bf47542.jpg";